var map = {
	"./icon1.png": "./src/assets/image/volume/icon1.png",
	"./icon2.png": "./src/assets/image/volume/icon2.png",
	"./icon3.png": "./src/assets/image/volume/icon3.png",
	"./icon4.png": "./src/assets/image/volume/icon4.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image/volume sync recursive ^\\.\\/icon.*\\.png$";